import type { NavigationScreenSiteState } from '@gitbook/app-navigation';
import {
    Dialog,
    DialogBody,
    DialogBrandedLayout,
    DialogCloseButton,
    DialogFooter,
    DialogHeader,
    DialogRoot,
    Heading,
} from '@gitbook/spine-react';

import { useSiteContext } from '../../../../state';
import { SiteTypeFeaturesList } from './FeaturesLists';
import { useUpgradeStatusModal } from './useUpgradeStatusModal';

/**
 * Shows the status of a pending upgrade on a site.
 * Handles both new and legacy pricing.
 */
export function UpgradeStatusModal(props: { screen: NavigationScreenSiteState }) {
    const { state, closeUpgradeStatusModal } = useUpgradeStatusModal(props.screen);

    return (
        <DialogRoot
            isOpen={state}
            onOpenChange={(isOpen) => {
                if (!isOpen) {
                    closeUpgradeStatusModal();
                }
            }}
        >
            <Dialog size="auto">
                <DialogBrandedLayout>
                    <UpgradeSuccesful />
                </DialogBrandedLayout>
            </Dialog>
        </DialogRoot>
    );
}

function UpgradeSuccesful() {
    const { site } = useSiteContext();
    return (
        <>
            <DialogHeader>
                <Heading>Upgrade successful</Heading>
            </DialogHeader>
            <DialogBody className="flex max-w-112 flex-col items-start gap-2">
                <p>Get the most out of your docs site with these features you just unlocked:</p>
                <SiteTypeFeaturesList siteType={site.type} />
            </DialogBody>
            <DialogFooter>
                <DialogCloseButton label="Got it" />
            </DialogFooter>
        </>
    );
}
